const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  staff: yup.string().required("Staff is required"),
  group: yup.string().required("Group is required"),
});

module.exports = {
  create,
};
